import { t } from "i18next";

export const strengthLabel = {
  normal: {
    label: t("passwordModal.strengthNormal"),
    width: 40,
  },
  strong: {
    label: t("passwordModal.strengthStrong"),
    width: 70,
  },
  veryStrong: {
    label: t("passwordModal.strengthVeryStrong"),
    width: 100,
  },
  weak: {
    label: t("passwordModal.strengthWeak"),
    width: 10,
  },
};

export const timerConstants = {
  interval: 1000,
  startTime: 60,
};
